module.exports = __webpack_public_path__ + "static/media/standard_BBQ.c5114e50.jpg";